import PropTypes from "prop-types";
import React, { useCallback, useState } from "react";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { ThemeProvider, useTheme } from "styled-components";
import { ButtonsVariant, Channel, Topic } from "../constants";
import { LocalizationMessages } from "../localization/messages";
import { UserContextSelectors } from "../redux/selectors";
import { MessageBrokerUtils } from "../utils";
import CTAButton from "./common/Button/CTAButton";

const LoginCTAButton = ({
  onClick,
  type,
  aCclassName,
  btnContext,
  trackingInfo
}) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState(false);
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);

  const handleCTA = e => {
    if (!window.rllogin || (window.rllogin && window.rllogin.isTemp)) {
      setIsLoading(true);
      const webLoginLoadedSubscription = MessageBrokerUtils.subscribe({
        channel: Channel.UI,
        topic: Topic.webLoginLoaded,
        callback: () => {
          setIsLoading(false);
          webLoginLoadedSubscription.unsubscribe();
        }
      });
    }

    onClick();
    e.preventDefault();
    e.stopPropagation();
    return true;
  };
  const contextClassId = btnContext + aCclassName;

  const getHoverColor = useCallback(() => {
    const style = theme.getHeaderButtonPcStyles();
    if (style.colors.outlinedBorderColor && !isAuthenticated) {
      return style.colors.outlinedBorderColor;
    } else {
      return style.colors.colorFontBlack;
    }
  }, [theme, isAuthenticated]);

  return (
    <ThemeProvider theme={theme.getHeaderButtonPcStyles()}>
      <CTAButton
        onClickFunc={handleCTA}
        title={formatMessage(LocalizationMessages.login)}
        type={type}
        id={contextClassId}
        color={theme.colors.brandColor}
        variant={ButtonsVariant.Outlined}
        hoverColor={getHoverColor()}
        trackingInfo={trackingInfo}
        isLoading={isLoading}
        dataTestId={contextClassId}
        isPremiumButton={false}
      />
    </ThemeProvider>
  );
};

LoginCTAButton.propTypes = {
  aCclassName: PropTypes.string,
  btnContext: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.string,
  trackingInfo: PropTypes.object
};

export default React.memo(LoginCTAButton);
